import React from 'react';
import { Layout, CreateServiceProvider as Create } from '@components/team';

const CreateServiceProvider = () => {
    return <Create />;
};

CreateServiceProvider.Layout = Layout;
export default CreateServiceProvider;
